import { defineMessages } from 'react-intl';

export default defineMessages({
  NFMFASessionMessages_1: {
    id: 'NFMFASessionMessages_1',
    defaultMessage: 'Welcome to ePASS',
  },
  NFMFASessionMessages_2: {
    id: 'NFMFASessionMessages_2',
    defaultMessage:
      'To begin this process, you must create a new NCID account or log in with an NCID account that you already have.',
  },
  NFMFASessionMessages_3: {
    id: 'NFMFASessionMessages_3',
    defaultMessage: "Don't have an account? ",
  },
  NFMFASessionMessages_4: {
    id: 'NFMFASessionMessages_4',
    defaultMessage: 'Sign up',
  },
  NFMFASessionMessages_5: {
    id: 'NFMFASessionMessages_5',
    defaultMessage: 'Log in',
  },
  NFMFASessionMessages_6: {
    id: 'NFMFASessionMessages_6',
    defaultMessage: 'Next',
  },
  NFMFASessionMessages_7: {
    id: 'NFMFASessionMessages_7',
    defaultMessage:
      'Based on your response, please create an {NFMFASessionMessages_Link} for yourself.',
  },
  NFMFASessionMessages_8: {
    id: 'NFMFASessionMessages_8',
    defaultMessage:
      'Based on your response, please create an {NFMFASessionMessages_Link} for the individual you are assisting.',
  },
  NFMFASessionMessages_9: {
    id: 'NFMFASessionMessages_9',
    defaultMessage:
      'Once you have created your NCID account, return to this screen to login to ePASS using your new NCID. Once you login to ePASS, you can continue the application process.',
  },
  NFMFASessionMessages_10: {
    id: 'NFMFASessionMessages_10',
    defaultMessage:
      'Once you have created your Business NCID account, return to this screen to login to ePASS using your new NCID. Once you login to ePASS, you will be given further direction on having your NCID configured for submitting applications.',
  },
  NFMFASessionMessages_11: {
    id: 'NFMFASessionMessages_11',
    defaultMessage:
      'An NCID account is required to log in to ePASS and submit applications. If you or the individual you are assisting does not have an NCID account you will need to create one.',
  },
  NFMFASessionMessages_12: {
    id: 'NFMFASessionMessages_12',
    defaultMessage: 'click here.',
  },
  NFMFASessionMessages_13: {
    id: 'NFMFASessionMessages_13',
    defaultMessage: 'Create an NCID Account',
  },
  NFMFASessionMessages_14: {
    id: 'NFMFASessionMessages_14',
    defaultMessage: 'Please select from the statements below:',
  },
  NFMFASessionMessages_15: {
    id: 'NFMFASessionMessages_15',
    defaultMessage: 'I am applying for myself and/or my family.',
  },
  NFMFASessionMessages_16: {
    id: 'NFMFASessionMessages_16',
    defaultMessage: 'I am assisting someone with applying.',
  },
  NFMFASessionMessages_17: {
    id: 'NFMFASessionMessages_17',
    defaultMessage: 'I am applying on behalf of someone else as a representative.',
  },
  NFMFASessionMessages_18: {
    id: 'NFMFASessionMessages_18',
    defaultMessage:
      'I am a community based organization/community partner assisting multiple individual households in applying.',
  },
  NFMFASessionMessages_19: {
    id: 'NFMFASessionMessages_19',
    defaultMessage: 'Log in',
  },
  NFMFASessionMessages_20: {
    id: 'NFMFASessionMessages_20',
    defaultMessage: 'For your security',
  },
  NFMFASessionMessages_21: {
    id: 'NFMFASessionMessages_21',
    defaultMessage: ' A 6-digit code was just sent to ',
  },
  NFMFASessionMessages_22: {
    id: 'NFMFASessionMessages_22',
    defaultMessage: 'Security code',
  },
  NFMFASessionMessages_23: {
    id: 'NFMFASessionMessages_23',
    defaultMessage: 'Confirm',
  },
  NFMFASessionMessages_24: {
    id: 'NFMFASessionMessages_24',
    defaultMessage: 'Ok',
  },
  NFMFASessionMessages_25: {
    id: 'NFMFASessionMessages_25',
    defaultMessage: 'Resend',
  },
  NFMFASessionMessages_26: {
    id: 'NFMFASessionMessages_26',
    defaultMessage: 'Oooops.... something went wrong! Please try again later.',
  },
  NFMFASessionMessages_27: {
    id: 'NFMFASessionMessages_27',
    defaultMessage: 'Retry',
  },
  NFMFASessionMessages_28: {
    id: 'NFMFASessionMessages_28',
    defaultMessage: 'Something went wrong!',
  },
  NFMFASessionMessages_29: {
    id: 'NFMFASessionMessages_29',
    defaultMessage: 'Incorrect log in',
  },
  NFMFASessionMessages_30: {
    id: 'NFMFASessionMessages_30',
    defaultMessage:
      'The security code entered does not match the one we sent you. Please re-enter the correct security code.',
  },
  NFMFASessionMessages_31: {
    id: 'NFMFASessionMessages_31',
    defaultMessage: 'For your security',
  },
  NFMFASessionMessages_32: {
    id: 'NFMFASessionMessages_32',
    defaultMessage:
      "It looks like you haven't used this device before to log in. We need to send you a 6-digit security code to complete the login process.",
  },
  NFMFASessionMessages_33: {
    id: 'NFMFASessionMessages_33',
    defaultMessage:
      'Please select a contact method below for us to send you the code. Text message and data rates may apply.',
  },
  NFMFASessionMessages_34: {
    id: 'NFMFASessionMessages_34',
    defaultMessage:
      ' If you temporarily do not have access to any of the contact methods above, you will need to login at another time when you do have access.',
  },
  NFMFASessionMessages_35: {
    id: 'NFMFASessionMessages_35',
    defaultMessage:
      'If you no longer have access to the contact methods above but you need to login to your account, you will need to select that you no longer have access to these contacts. Doing so will remove the upgraded features of your account.',
  },
  NFMFASessionMessages_36: {
    id: 'NFMFASessionMessages_36',
    defaultMessage: 'Remember this device?',
  },
  NFMFASessionMessages_37: {
    id: 'NFMFASessionMessages_37',
    defaultMessage:
      "If you would like us to remember the computer or mobile device you are now using, you can select to remember this device so that you do not have to enter a security code each time you log in. Otherwise, select 'Do not remember this device'.",
  },
  NFMFASessionMessages_38: {
    id: 'NFMFASessionMessages_38',
    defaultMessage: 'Remember this device.',
  },
   /* NFIS-40824  Start  Removing the bold tag from the Radiobutton label, as with the bold tag the radio button was not rendereing. This is a temporary fix.*/
  NFMFASessionMessages_39: {
    id: 'NFMFASessionMessages_39',
    defaultMessage:
      " Remember this device. This way I won't have to enter a security code each time I log in from this device.",
  },
   /* NFIS-40824  End  Removing the bold tag from the Radiobutton label, as with the bold tag the radio button was not rendereing. This is a temporary fix.*/
  NFMFASessionMessages_40: {
    id: 'NFMFASessionMessages_40',
    defaultMessage: 'Do not remember this device.',
  },
  NFMFASessionMessages_41: {
    id: 'NFMFASessionMessages_41',
    defaultMessage: 'Confirm',
  },
  NFMFASessionMessages_42: {
    id: 'NFMFASessionMessages_42',
    defaultMessage: 'Account temporarily locked',
  },
  NFMFASessionMessages_43: {
    id: 'NFMFASessionMessages_43',
    defaultMessage:
      'Due to many unsuccessful attempts to log in, your account is now locked for your security. Your account will remain locked for the next 30 minutes.',
  },
  NFMFASessionMessages_44: {
    id: 'NFMFASessionMessages_44',
    defaultMessage: 'You may attempt to log in again after the 30 minutes has expired.',
  },
  NFMFASessionMessages_45: {
    id: 'NFMFASessionMessages_45',
    defaultMessage: "Didn't get a security code? ",
  },
  NFMFASessionMessages_46: {
    id: 'NFMFASessionMessages_46',
    defaultMessage: 'Cancel',
  },
  NFMFASessionMessages_47: {
    id: 'NFMFASessionMessages_47',
    defaultMessage: 'The security code sent to ',
  },
  NFMFASessionMessages_48: {
    id: 'NFMFASessionMessages_48',
    defaultMessage:
      'Make sure you use the most recent code sent to you. Every time that you select resend a code, the prior code sent will be cancelled out and only the most recent code is valid.',
  },
   /* NFIS-40824  Start  Removing the bold tag from the Radiobutton label, as with the bold tag the radio button was not rendereing. This is a temporary fix.*/
  NFMFASessionMessages_49: {
    id: 'NFMFASessionMessages_49',
    defaultMessage:
      " Do not remember this device. This is not a device I would like to be remembered (such as a library computer) because I don't use it regularly.",
  },
   /* NFIS-40824  End  Removing the bold tag from the Radiobutton label, as with the bold tag the radio button was not rendereing. This is a temporary fix.*/
  NFMFASessionMessages_50: {
    id: 'NFMFASessionMessages_50',
    defaultMessage:
      'For more information regarding applying for someone else as a representative, or applying for multiple individual households at the same time, please ',
  },
  NFMFASessionMessages_51: {
    id: 'NFMFASessionMessages_51',
    defaultMessage: 'Continue',
  },
  NFMFASessionMessages_52: {
    id: 'NFMFASessionMessages_52',
    defaultMessage: 'North Carolina Identity Management (NCID) Redirect',
  },
  NFMFASessionMessages_53: {
    id: 'NFMFASessionMessages_53',
    defaultMessage:
      "By selecting 'Continue', a new window will open to the North Carolina Identity Management (NCID) web page.",
  },
  NFMFASessionMessages_54: {
    id: 'NFMFASessionMessages_54',
    defaultMessage:
      'An NCID account is required in order to submit applications and manage your applications.',
  },
  NFMFASessionMessages_55: {
    id: 'NFMFASessionMessages_55',
    defaultMessage:
      "Please select 'Continue' to create or manage your NCID account. Once your NCID account is created, close the newly opened window.",
  },
  NFMFASessionMessages_56: {
    id: 'NFMFASessionMessages_56',
    defaultMessage: 'Close',
  },
  NFMFASessionMessages_57: {
    id: 'NFMFASessionMessages_57',
    defaultMessage:
      'Food and Nutrition Services and Medicaid policy allows a representative designated by an applicant to apply for benefits, on behalf of the applicant. If you are a representative ( or designated authorized representative) for an individual or household and have minimum information necessary to apply for benefits for the individual or household, you can apply for benefits through ePASS.',
  },
  NFMFASessionMessages_58: {
    id: 'NFMFASessionMessages_58',
    defaultMessage: 'To apply for an individual or household, an NCID account is required.',
  },
  NFMFASessionMessages_59: {
    id: 'NFMFASessionMessages_59',
    defaultMessage:
      'If you are ASSISTING an individual or household with submitting their application only:',
  },
  NFMFASessionMessages_60: {
    id: 'NFMFASessionMessages_60',
    defaultMessage:
      'Please login using the primary applicant’s NCID if you are starting a new application. If this is the first time the primary applicant is using ePASS, please create an ',
  },
  NFMFASessionMessages_61: {
    id: 'NFMFASessionMessages_61',
    defaultMessage: ' to create an individual NCID.',
  },
  NFMFASessionMessages_62: {
    id: 'NFMFASessionMessages_62',
    defaultMessage: ' here',
  },
  NFMFASessionMessages_63: {
    id: 'NFMFASessionMessages_63',
    defaultMessage:
      'If you are APPLYING on behalf of an individual or household as their representative:',
  },
  NFMFASessionMessages_64: {
    id: 'NFMFASessionMessages_64',
    defaultMessage:
      'You may login using your own NCID account an indicate prior to the start of the application that you are applying on behalf of someone else. Access to the individual or household’s case information will be limited to what you provided on the application and the application status unless you have been designated as an Authorized Representative.',
  },
  NFMFASessionMessages_65: {
    id: 'NFMFASessionMessages_65',
    defaultMessage:
      'A Designated Authorized Representative is authorized to talk about the application, see the individual or household’s information, and act for the individual or household on matters related to the application and benefit information. Designated Authorized Representatives are given permission to report changes, provided information, receive Medicaid notices, complete re-enrollment/ redeterminations, receive case status, and view information contained within the case file or pertaining to the case, other that information from another source specifically designated as ‘Confidential’ or ‘Do not Release’. For Food and Nutrition Services, an authorized representative may also be given permission to receive an EBT card to purchase food for the individual or household.',
  },
  NFMFASessionMessages_66: {
    id: 'NFMFASessionMessages_66',
    defaultMessage:
      'To designate an Authorized Representative, a Designation of Authorized Representative consent form must be completed by the head of household/ applicant. The form should be returned (along with verification of identify for the authorized representative and head of household) to the local Department of Social Services. Further documentation may be required for individuals designated as Legal Guardian, Power of Attorney or Health Care Power of Attorney. Please contact your ',
  },
  NFMFASessionMessages_67: {
    id: 'NFMFASessionMessages_67',
    defaultMessage: 'local Department of Social Services',
  },
  NFMFASessionMessages_68: {
    id: 'NFMFASessionMessages_68',
    defaultMessage: ' to obtain the appropriate forms.',
  },
  NFMFASessionMessages_69: {
    id: 'NFMFASessionMessages_69',
    defaultMessage:
      'Please do not create or submit multiple applications for the same type for the same individual or household.',
  },
  NFMFASessionMessages_70: {
    id: 'NFMFASessionMessages_70',
    defaultMessage: 'How do I apply on behalf of more that one individual or household?',
  },
  NFMFASessionMessages_71: {
    id: 'NFMFASessionMessages_71',
    defaultMessage:
      'If you represent a business or organization who is authorized to apply on behalf of more than one applicant or household at the same time, you must have a ',
  },
  NFMFASessionMessages_72: {
    id: 'NFMFASessionMessages_72',
    defaultMessage:
      ' to create an NCID. Once you have established a Business NCID Account, your Business NCID must be configured to enable the submission of applications. ',
  },
  NFMFASessionMessages_73: {
    id: 'NFMFASessionMessages_73',
    defaultMessage:
      'Once you log in to ePASS with your Business NCID, you will be given further direction on having your account configured.',
  },
  NFMFASessionMessages_74: {
    id: 'NFMFASessionMessages_74',
    defaultMessage:
      'Qualified Medical Provider staff are not allowed to act as an authorized representative for a Medicaid applicant for whom they are submitting a Presumptive Eligibility determination.',
  },
  NFMFASessionMessages_75: {
    id: 'NFMFASessionMessages_75',
    defaultMessage: 'Applying on behalf of someone else?',
  },
  NFMFASessionMessages_76: {
    id: 'NFMFASessionMessages_76',
    defaultMessage: 'Individual NCID Account',
  },
  NFMFASessionMessages_77: {
    id: 'NFMFASessionMessages_77',
    defaultMessage:
      ' for the primary applicant. The primary applicant is the individual or head of household who is requesting benefits and for whom you are assisting with applying. Click ',
  },
  NFMFASessionMessages_78: {
    id: 'NFMFASessionMessages_78',
    defaultMessage: 'Business NCID Account',
  },
  NFMFASessionMessages_79: {
    id: 'NFMFASessionMessages_79',
    defaultMessage: '. Click ',
  },
  NFMFASessionMessages_80: {
    id: 'NFMFASessionMessages_80',
    defaultMessage: 'Continue to NCID',
  },
  NFMFASessionMessages_81: {
    id: 'NFMFASessionMessages_81',
    defaultMessage:
      'When you make a selection, more text will display to help you determine what type of NCID account to create.',
  },
  NFMFASessionMessages_82: {
    id: 'NFMFASessionMessages_82',
    defaultMessage: '. Please enter the code below.',
  },
  NFMFASessionMessages_83: {
    id: 'NFMFASessionMessages_83',
    defaultMessage:
      " may take a minute or two to receive. If you have waited a minute or two and still have not received a security code, select 'Resend' below to send a new security code.",
  },
  NFMFASessionMessages_84: {
    id: 'NFMFASessionMessages_84',
    defaultMessage: 'Resend security code',
  },
  NFMFASessionMessages_85: {
    id: 'NFMFASessionMessages_85',
    defaultMessage: 'Account privileges disabled',
  },
  NFMFASessionMessages_86: {
    id: 'NFMFASessionMessages_86',
    defaultMessage:
      'We are unable to complete the secure login process to your account. We disabled some features of your account to protect your personal information.',
  },
  NFMFASessionMessages_87: {
    id: 'NFMFASessionMessages_87',
    defaultMessage: 'Please contact your ',
  },
  NFMFASessionMessages_88: {
    id: 'NFMFASessionMessages_88',
    defaultMessage: "Select 'Ok' to continue to your account home page.",
  },
  NFMFASessionMessages_89: {
    id: 'NFMFASessionMessages_89',
    defaultMessage: 'County Department of Social Services',
  },
  NFMFASessionMessages_90: {
    id: 'NFMFASessionMessages_90',
    defaultMessage: ' office to have your account privileges turned back on.',
  },
  NFMFASessionMessages_91: {
    id: 'NFMFASessionMessages_91',
    defaultMessage: 'Your account is locked for 30 minutes and the time has not expired.',
  },
  NFMFASessionMessages_92: {
    id: 'NFMFASessionMessages_92',
    defaultMessage: 'Please try again after the 30 minutes has passed.',
  },
  NFMFASessionMessages_93: {
    id: 'NFMFASessionMessages_93',
    defaultMessage: 'Home',
  },
  NFMFASessionMessages_94: {
    id: 'NFMFASessionMessages_94',
    defaultMessage: 'Back',
  },
  NFMFASessionMessages_95: {
    id: 'NFMFASessionMessages_95',
    defaultMessage: 'The security code was entered successfully!',
  },
  NFMFASessionMessages_96: {
    id: 'NFMFASessionMessages_96',
    defaultMessage: 'Resend code',
  },
  NFMFASessionMessages_97: {
    id: 'NFMFASessionMessages_97',
    defaultMessage: 'Login',
  },
  NFMFASessionMessages_99: {
    id: 'NFMFASessionMessages_99',
    defaultMessage: 'Individual NCID account',
  },
  NFMFASessionMessages_100: {
    id: 'NFMFASessionMessages_100',
    defaultMessage: 'Business NCID account',
  },
  NFMFASessionMessages_101: {
    id: 'NFMFASessionMessages_101',
    defaultMessage:
      'We are unable to complete the secure login process to your account. We disabled some features of your account to protect your personal information.',
  },
  NFMFASessionMessages_102: {
    id: 'NFMFASessionMessages_102',
    defaultMessage: 'Please contact your local',
  },
  NFMFASessionMessages_103: {
    id: 'NFMFASessionMessages_103',
    defaultMessage: ' County Department of Social Services ',
  },
  NFMFASessionMessages_104: {
    id: 'NFMFASessionMessages_104',
    defaultMessage: 'office to have your account privileges turned back on.',
  },
  NFMFASessionMessages_105: {
    id: 'NFMFASessionMessages_105',
    defaultMessage: "Select 'Ok' to continue to your account home page.",
  },
  NFMFASessionMessages_106: {
    id: 'NFMFASessionMessages_106',
    defaultMessage: 'Account privileges disabled',
  },
  NFMFASessionMessages_107: {
    id: 'NFMFASessionMessages_107',
    defaultMessage: 'Create NCID Account',
  },
  NFMFASessionMessages_108: {
    id: 'NFMFASessionMessages_108',
    defaultMessage:
      'The security code entered does not match the one we sent you. Please re-enter the correct security code.',
  },
  NFMFASessionMessages_109: {
    id: 'NFMFASessionMessages_109',
    defaultMessage:
      'The log in process has expired. Please close this window and start the log in process again.',
  },
  NFMFASessionMessages_110: {
    id: 'NFMFASessionMessages_110',
    defaultMessage:
      'SMS Text Message confirmation service is currently unavailable. Please try again later.',
  },
  NFMFASessionMessages_111: {
    id: 'NFMFASessionMessages_111',
    defaultMessage: 'Email confirmation service is currently unavailable. Please try again later.',
  },
  NFMFASessionMessages_112: {
    id: 'NFMFASessionMessages_112',
    defaultMessage: 'The service is currently unavailable. Please try again later.',
  },
  NFMFASessionMessages_113: {
    id: 'NFMFASessionMessages_113',
    defaultMessage: 'Account locked',
  },
  NFMFASessionMessages_114: {
    id: 'NFMFASessionMessages_114',
    defaultMessage: 'We are unable to complete the secure login process to your account and your account used to submit Auto Newborn referrals is locked.',
  },
  NFMFASessionMessages_115: {
    id: 'NFMFASessionMessages_115',
    defaultMessage: 'Please contact the NC FAST Help Desk at 919-813-5400, option 5 to receive assistance for unlocking your account.The NC FAST Help Desk is open Monday through Friday from 8:00 am - 6:00 pm, closed on state holidays.',
  },
  NFMFASessionMessages_116: {
    id: 'NFMFASessionMessages_116',
    defaultMessage: 'Please be ready to provide your NCID account username that you use to log in to ePASS. Take a screenshot or picture of this screen to assist when you call in.',
  },
  NFMFASessionMessages_117: {
    id: 'NFMFASessionMessages_117',
    defaultMessage: 'Loading...',
  },
});
